import { DataProvider, Identifier } from "react-admin";
import { findOne } from "../common/common";
import { JS, readStages, Stage } from "../workflow/reader";

const fillRealId = (where, from, to, records) => {
    for (const internalId of from[where]) {
        to[where].push(records[internalId].id);
    }
};

// Enregistrement des étapes
const createStages = async (dataProvider: DataProvider, stages: [Stage?], workflowId: Identifier) => {
    const records = {};
    for (const currentStage of stages) {
        const data = {
            internalId: currentStage.id,
            name: currentStage.name,
            workflowId: workflowId,
            isStarting: currentStage.isStarting
        };
        await dataProvider.create("stage", { data }).then(({ data }) => {
            records[currentStage.id] = data;
        });
    }
    return records;
};

const updateStages = async (dataProvider: DataProvider, stages: [Stage?], records) => {
    // Maj des étapes
    for (const currentStage of stages) {
        const data = {
            incoming: [],
            incomingError: [],
            outgoing: [],
            outgoingError: []
        };
        for (const where in data) {
            fillRealId(where, currentStage, data, records);
        }
        for (const where in data) {
            data[where] = `{${data[where].join(",")}}`;
        }
        const previousData = records[currentStage.id];
        const id = previousData.id;
        await dataProvider.update("stage", { id, data, previousData });
    }
};

export const createWorflowStages = async (dataProvider: DataProvider, js: JS, workflowId: Identifier) => {
    const stages = readStages(js);
    const records = await createStages(dataProvider, stages, workflowId);
    await updateStages(dataProvider, stages, records);
}

/**
 * Récupération d'un stage
 * @param dataProvider dataProvider
 * @param workflowId worlflow id
 * @param internalId internal id
 * @returns stage
 */
export const getStage = async (dataProvider: DataProvider, workflowId: Identifier, internalId: string) => {
    return await findOne(dataProvider, "stage", { workflowId, internalId });
};